// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root { --bg:#0e1117; --panel:#161b22; --muted:#9aa4b2; --text:#e6edf3; --primary:#6ea8fe; --success:#3fb950; --warn:#f2cc60; --danger:#ff6b6b; --border:#262b36; }
*{box-sizing:border-box}
html,body{height:100%}
body{margin:0;font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,Arial,sans-serif;background:var(--bg);color:var(--text)}

.sidebar {
  width: 250px;
  transition: width 0.3s ease, transform 0.3s ease;
  background-color: #111;
  overflow: hidden;
}
.sidebar.hidden {
  transform: translateX(-250px); /* empurra pra fora da tela */
}

.brand{display:flex;gap:10px;align-items:center;padding:16px 14px;border-bottom:1px solid var(--border)}


.brand-text small{color:var(--muted);display:block;margin-top:2px}
.menu{padding:10px}
.menu-section{color:var(--muted);font-size:12px;text-transform:uppercase;letter-spacing:.08em;padding:10px}
.menu-item{display:block;padding:10px 12px;border-radius:10px;color:var(--text);text-decoration:none}
.menu-item:hover{background:rgba(110,168,254,.08)}
.sidebar-footer{margin-top:auto;padding:12px;display:flex;gap:8px;border-top:1px solid var(--border);align-items:center}
.main {
  display: flex;
  height: 100vh; /* ocupa toda a altura da tela */
  overflow: hidden; /* evita scroll global */
  z-index:10;
}
.topbar{display:flex;align-items:center;justify-content:space-between;padding:10px 14px;border-bottom:1px solid var(--border);background:var(--panel)}
.icon-btn{background:transparent;border:1px solid var(--border);color:var(--text);border-radius:10px;padding:8px 10px;cursor:pointer}
.search input{background:transparent;border:1px solid var(--border);color:var(--text);border-radius:10px;padding:8px 10px;min-width:220px}
.avatar{width:30px;height:30px;border-radius:999px;background:#334155;display:grid;place-items:center;font-size:12px}
.content {
  flex: 1 1;
  overflow-y: auto; /* scroll só aqui */
  
  padding: 20px;
}
.footer{padding:12px 14px;border-top:1px solid var(--border);color:var(--muted);background:var(--panel)}
.card{background:var(--panel);border:1px solid var(--border);border-radius:12px;padding:14px;overflow-x:auto}
.card h2{margin:0 0 6px 0;font-size:18px}
.card .sub{color:var(--muted);font-size:12px;margin-bottom:6px}
.grid{display:grid;gap:12px}
.grid.cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}
.grid.cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}
.form{display:grid;gap:10px}
.form .row{display:grid;gap:10px;grid-template-columns:repeat(2,minmax(0,1fr))}
.form label{display:grid;gap:6px;font-size:12px;color:var(--muted)}
.form input,
.form select,
.form textarea {
  background-color: var(--panel); /* fundo escuro */
  color: var(--text);             /* texto claro */
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 10px 12px;
}
.swal2-popup {
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important; /* garante alinhamento à esquerda */
  justify-content: center !important;
  width: 420px !important;
  background-color: var(--panel) !important;
  color: var(--text) !important;
  border-radius: 12px !important;
  padding: 32px 36px !important;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.6) !important;
}
.swal2-html-container {
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible !important;
}
/* Título */
.swal2-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: var(--text) !important;
  text-align: left !important;
  margin-left: -25px !important;
  margin-bottom: 18px !important;
}

/* Labels */
.swal2-popup label {
  display: block !important;
  text-align: left !important;
  font-size: 13px !important;
  color: var(--muted) !important;
  margin-bottom: 1px !important;
}

/* Inputs */
.swal2-input {
  width: 100% !important;
  background-color: var(--bg) !important;
  color: var(--text) !important;
  border: 1px solid var(--border) !important;
  border-radius: 8px !important;
  padding: 10px 12px !important;
  font-size: 14px !important;
  margin-bottom: 16px !important;
  margin-left: 0px !important;
  box-shadow: none !important;
}



.swal2-popup.detalhes-popup {
  width: 1200px !important;
  max-width: 90% !important; /* responsivo */
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
  justify-content: center !important;
}
.swal2-html-container.detalhes-container {
  max-height: 600px !important;
  overflow-y: auto !important;
}
.btn.link {
  background-color: #17a2b8; /* azul turquesa */
  color: #fff;
}
.btn.link:hover {
  background-color: #138496;
}

.swal2-input::placeholder {
  color: var(--muted) !important;
}

.swal2-input:focus {
  border-color: var(--primary) !important;
  outline: none !important;
}

/* Botões */
.swal2-confirm {
  background-color: var(--success) !important;
  color: #fff !important;
  border-radius: 8px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  box-shadow: none !important;
}
.swal2-actions {
  display: flex !important;
  justify-content: center !important;
  margin-top: 10px !important;
}
.swal2-checkbox,
.swal2-checkbox input,
.swal2-checkbox {
  display: none !important;
  visibility: hidden !important;
  height: 0 !important;
  width: 0 !important;
  overflow: hidden !important;
}
.swal2-label {
  display: block !important;
  text-align: left !important;
  font-size: 13px !important;
  color: var(--muted) !important;
  margin-bottom: 1px !important;
  margin-left: 2px !important;
}
.swal2-input {
  margin-bottom: 14px !important;
}

/* Remove scrolls e barras */
.swal2-popup::-webkit-scrollbar,
.swal2-html-container::-webkit-scrollbar {
  display: none !important;
}

.swal2-cancel {
  background-color: var(--panel) !important;
  color: var(--text) !important;
  border: 1px solid var(--border) !important;
  border-radius: 8px !important;
  padding: 8px 18px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}

.swal2-timer-progress-bar-container,
.swal2-timer-progress-bar {
  display: none !important;
}


.swal2-input::placeholder {
  color: var(--muted) !important;
}

.inline{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.badge{display:inline-flex;align-items:center;gap:6px;padding:3px 8px;border-radius:999px;border:1px solid var(--border);color:var(--muted);font-size:12px}
.badge.on{color:#0b1220;background:#a7f3d0;border-color:#a7f3d0}
.badge.off{background:#1f2937}
.btn{background:var(--panel);border:1px solid var(--border);color:var(--text);border-radius:10px;padding:10px 14px;cursor:pointer}
.btn:hover{border-color:var(--primary)}
.btn.primary{background:var(--primary);color:#fff;border-color:var(--primary)}
.btn.success{background:var(--success);color:#fff;border-color:var(--success)}
.btn.danger{background:var(--danger);color:#fff;border-color:var(--danger)}
.btn-sm{padding:8px 12px;font-size:12px}
.table{width:100%;border-collapse:collapse}
.table th,.table td{border-bottom:1px solid var(--border);padding:8px 6px;text-align:left}
.toast{position:fixed;bottom:16px;right:16px;background:var(--panel);border:1px solid var(--border);border-radius:10px;padding:10px 12px;box-shadow:0 10px 30px rgba(0,0,0,.25);z-index:11000}
.modal{
background: var(--panel);
  color: var(--text);
  border-radius: 10px;
  padding: 30px 40px;
  max-width: 480px;
  margin: 40px auto;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
  z-index:10000}
/* Título */
.modal h2 {
  text-align: center;
  font-size: 22px;
  margin-bottom: 25px;
  color: var(--text);
}
/* Labels alinhados à esquerda */
.modal label {
  display: block;
  text-align: left;
  font-size: 13px;
  color: var(--muted);
  margin-bottom: 4px;
  margin-left: 4px;
}

/* Inputs com fundo escuro e borda suave */
.modal input[type="text"],
.modal input[type="email"],
.modal input[type="tel"],
.modal input[type="password"],
.modal input[type="number"] {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background-color: var(--panel); /* fundo escuro */
  color: var(--text); /* texto claro */
  font-size: 14px;
  margin-bottom: 14px;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.modal input:focus {
  border-color: var(--primary);
  background-color: rgba(110, 168, 254, 0.1);
  outline: none;
}
.modal input::placeholder {
  color: var(--muted); /* cor suave para placeholder */
}

/* Botão OK */
.modal button {
  display: block;
  margin: 20px auto 0;
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 24px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modal button:hover {
  background: var(--primary-hover);
}
.modal>.box{background:var(--panel);border:1px solid var(--border);border-radius:12px;padding:16px;min-width:360px;max-width:90vw;position:relative;z-index:10001}
.hidden{display:none!important}
/* Responsive */
@media (max-width: 1200px){ .grid.cols-3{grid-template-columns:repeat(2,minmax(0,1fr))} }
@media (max-width: 900px) {
  .layout {
    grid-template-columns: 1fr;
  }

.sidebar {
  width: 220px;
  background-color: #121212;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

  /* Sidebar visível apenas quando NÃO estiver oculta */
  body:not(.hide-sidebar) .sidebar {
    transform: translateX(0);
  }

  /* Sidebar oculta (mantém compatibilidade com telas grandes) */
  body.hide-sidebar .sidebar {
    display: none;
    transform: translateX(-100%);
  }

  .topbar .search {
    display: none;
  }

  .btn,
  .icon-btn {
    min-height: 44px;
  }
}
@media (max-width: 768px){
  .grid.cols-2,.grid.cols-3{grid-template-columns:1fr}
  .form .row{grid-template-columns:1fr}
  .modal>.box{min-width:94vw;max-height:90vh;overflow:auto}
}
.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.filters label {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.filters select,
.filters input[type="date"],
.filters button {
  margin-top: 4px;
  padding: 6px;
  font-size: 14px;
}

.swal-top {
  z-index: 10002 !important;
}
.swal2-container {
  z-index: 99999 !important;
}



/* Responsivo para celular */
@media (max-width: 768px) {
  .filters {
    flex-direction: column;
    align-items: stretch;
  }
  .filters select,
  .filters input[type="date"],
  .filters button {
    width: 100%;
  }
}

.sidebar {
  background: var(--panel);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  width: 240px;
  min-height: 100vh;
  padding-top: 0;
}

.brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  
  border-bottom: 1px solid var(--border);
}

.logo img {
  width: 120px;
  height: auto;
  display: block;
}

.brand-text {
  text-align: center;
  color: var(--text);
  font-size: 14px;
}

.brand-text strong {
  color: var(--primary);
  font-size: 16px;
}

.menu {
  padding: 10px 0;
}

.menu-section {
  color: var(--muted);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 10px 16px 4px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  color: var(--text);
  text-decoration: none;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.menu-item:hover {
  background: rgba(110, 168, 254, 0.1);
}

.menu-item i {
  font-size: 16px;
  color: var(--primary);
}

.sidebar-footer {
  margin-top: auto;
  padding: 12px 16px;
  border-top: 1px solid var(--border);
  color: var(--muted);
  font-size: 12px;
  text-align: center;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.logo img {
  width: 120px; /* ajusta conforme o tamanho real do arquivo */
  height: auto;
  border: none;
  outline: none;
  box-shadow: none;
  display: block;
}

.logout {

  background-color: var(--primary) !important; /* vermelho */
  color: #fff;
  padding: 2px 2px;
  border-radius: 4px;
  cursor: pointer;
}

.logout:hover {
  background-color: #c82333;
}

.login-container {
  max-width: 400px;
  margin: 100px auto;
  padding: 30px;
  background-color: #1a1a1a;
  border-radius: 8px;
  color: #fff;
}


.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #121212;
}

.login-box {
  background-color: var(--panel);
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  width: 30%;
  color: #fff;
}

.login-box h3 {
  margin-bottom: 20px;
  text-align: center;
  font-weight: 600;
}

.login-form label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
}

.login-form input {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: none;
  border-radius: 5px;
  background-color: #e9eef5;
}

.login-buttons {
  display: flex;
  justify-content: space-between;
}

.loginbtn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
}

.loginbtn-green {
  background-color: #28a745;
  color: #fff;
}

.loginbtn-green:hover {
  background-color: #218838;
}

.loginbtn-dark {
  background-color: #343a40;
  color: #fff;
}

.loginbtn-dark:hover {
  background-color: #23272b;
}


.card-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
}

.card.small {
  flex: 1 1;
  min-width: 300px;
  background-color: var(--panel);
  border: 1px solid #2b2c30;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0,0,0,0.3);
  transition: transform 0.2s ease;
}

.card.small:hover {
  transform: translateY(-4px);
}

.card.small h4 {
  margin-bottom: 10px;
  color: #4da3ff;
}

.card.small p {
  margin: 4px 0;
  color: #ccc;
}
.indicadores {
  display: flex;
  align-items: center;
}

.indicadores .evolucao {
  margin-left: 5px !important;
}

.card canvas {
  width: 100% !important;
  height: 280px !important; /* altura fixa e elegante */
  display: block;
}



/* ===== Suporte ===== */.suporte-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 700px;
  margin: 0 auto;
  padding: 20px;
}

/* Cards */
.suporte-container .card {
  background-color: #fff;   /* fundo branco */
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 25px;
  color: #000;              /* texto preto */
  text-align: left;
}

/* Título */
.suporte-container h2 {
  margin: 0 0 10px 0;
  font-size: 20px;
  color: #4caf50;
}


/* Formulário */
#formSuporte {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

/* Labels */
#formSuporte label {
  font-size: 14px;
  color: #000; /* texto preto */
  display: flex;
  flex-direction: column;
  gap: 5px;
}

/* Inputs, selects e textarea */
#formSuporte .form-input,
#formSuporte select,
#formSuporte textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #fff;   /* fundo branco */
  color: #000;              /* texto preto */
}

#formSuporte textarea {
  min-height: 120px;
  resize: vertical;
}

/* Botão principal */
#formSuporte .btn.primary {
  background-color: #4caf50;
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;
}

#formSuporte .btn.primary:hover {
  background-color: #45a049;
}

/* Rodapé */
.suporte-container .rodape {
  font-size: 13px;
  color: #555;
  margin-top: 20px;
}

.suporte-container .rodape a {
  color: #4caf50;
  text-decoration: none;
}


/* Rodapé */
.suporte-container .rodape {
  font-size: 13px;
  color: #aaa;
  margin-top: 15px;
}

.suporte-container .rodape a {
  color: #4caf50;
  text-decoration: none;
}

.suporte-container p {
  color: #000 !important;   /* força texto preto */
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
}

/* ===== Termo de Uso ===== *//* Container geral */
.termodeuso-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
}

/* Cards */
.termodeuso-container .card {
  background-color: #fff;   /* fundo branco */
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 25px;
  color: #000;              /* texto preto */
  text-align: left;
}

/* Título principal */
.termodeuso-container h2 {
  color: #4caf50;
  margin-bottom: 10px;
}

/* Subtítulos */
.termodeuso-container h3 {
  color: #4caf50;
  margin-top: 20px;
  margin-bottom: 8px;
  font-size: 16px;
}

/* Texto */
.termodeuso-container p {
  color: #333;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
}

/* Listas */
.termodeuso-container ul {
  margin-left: 20px;
  color: #333;
  font-size: 14px;
  line-height: 1.6;
}

.termodeuso-container li {
  color: #333;
  
}

/* Rodapé */
.termodeuso-container .rodape {
  font-size: 13px;
  color: #555;
  margin-top: 20px;
}

.termodeuso-container .rodape a {
  color: #4caf50;
  text-decoration: none;
}


/* ===== Política de Privacidade ===== */.politicaprivacidade-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
}

/* Cards */
.politicaprivacidade-container .card {
  background-color: #fff;   /* fundo branco */
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 25px;
  color: #000;              /* texto preto */
  text-align: left;
}

/* Título principal */
.politicaprivacidade-container h2 {
  color: #4caf50;
  margin-bottom: 10px;
}

/* Subtítulos */
.politicaprivacidade-container h3 {
  color: #4caf50;
  margin-top: 20px;
  margin-bottom: 8px;
  font-size: 16px;
}

/* Texto */
.politicaprivacidade-container p {
  color: #333;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
}

/* Listas */
.politicaprivacidade-container ul {
  margin-left: 20px;
  color: #333;
  font-size: 14px;
  line-height: 1.6;
}

/* Rodapé */
.politicaprivacidade-container .rodape {
  font-size: 13px;
  color: #555;
  margin-top: 20px;
}

.politicaprivacidade-container .rodape a {
  color: #4caf50;
  text-decoration: none;
}

body.hide-sidebar .main {
  width: 100%;
  max-width: 800px;   /* limite máximo */
  margin: 0 auto;     /* centraliza horizontalmente */
  padding: 20px;
}

body.hide-sidebar .layout {
  grid-template-columns: 1fr; /* só uma coluna */
}
/* Opcional: limitar largura dos cards dentro do Suporte */
body.hide-sidebar .main .card {
  width: 100%;
  max-width: 700px; /* deixa o card mais estreito e centralizado */
}
.layout {
  display: grid;
  grid-template-columns: 240px 1fr; /* exemplo: sidebar 240px + conteúdo */
}

.swal-recuperar-senha {
  background: #fff !important;
  color: #000 !important;
}

.swal-recuperar-senha .swal2-title,
.swal-recuperar-senha .swal2-html-container label {
  color: #000 !important;
}

.swal-recuperar-senha .swal2-input {
  background: #fff !important;
  color: #000 !important;
  border: 1px solid #ccc !important;
}

.swal-recuperar-senha .swal2-input::placeholder {
  color: #666 !important;
}

.swal-recuperar-senha .swal2-confirm {
  background-color: #4caf50 !important;
  color: #fff !important;
}

.swal-recuperar-senha .swal2-cancel {
  background-color: #f5f5f5 !important;
  color: #000 !important;
  border: 1px solid #ccc !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":";AACA,QAAQ,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAClK,EAAE,qBAAqB;AACvB,UAAU,WAAW;AACrB,KAAK,QAAQ,CAAC,6GAA6G,CAAC,oBAAoB,CAAC,iBAAiB;;AAElK;EACE,YAAY;EACZ,gDAAgD;EAChD,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,6BAA6B,EAAE,6BAA6B;AAC9D;;AAEA,OAAO,YAAY,CAAC,QAAQ,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,qCAAqC;;;AAGvG,kBAAkB,kBAAkB,CAAC,aAAa,CAAC,cAAc;AACjE,MAAM,YAAY;AAClB,cAAc,kBAAkB,CAAC,cAAc,CAAC,wBAAwB,CAAC,oBAAoB,CAAC,YAAY;AAC1G,WAAW,aAAa,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,oBAAoB;AACpG,iBAAiB,gCAAgC;AACjD,gBAAgB,eAAe,CAAC,YAAY,CAAC,YAAY,CAAC,OAAO,CAAC,kCAAkC,CAAC,kBAAkB;AACvH;EACE,aAAa;EACb,aAAa,EAAE,gCAAgC;EAC/C,gBAAgB,EAAE,wBAAwB;EAC1C,UAAU;AACZ;AACA,QAAQ,YAAY,CAAC,kBAAkB,CAAC,6BAA6B,CAAC,iBAAiB,CAAC,qCAAqC,CAAC,uBAAuB;AACrJ,UAAU,sBAAsB,CAAC,8BAA8B,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,cAAc;AACpI,cAAc,sBAAsB,CAAC,8BAA8B,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,eAAe;AACzI,QAAQ,UAAU,CAAC,WAAW,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,YAAY,CAAC,kBAAkB,CAAC,cAAc;AACpH;EACE,SAAO;EACP,gBAAgB,EAAE,mBAAmB;;EAErC,aAAa;AACf;AACA,QAAQ,iBAAiB,CAAC,kCAAkC,CAAC,kBAAkB,CAAC,uBAAuB;AACvG,MAAM,uBAAuB,CAAC,8BAA8B,CAAC,kBAAkB,CAAC,YAAY,CAAC,eAAe;AAC5G,SAAS,gBAAgB,CAAC,cAAc;AACxC,WAAW,kBAAkB,CAAC,cAAc,CAAC,iBAAiB;AAC9D,MAAM,YAAY,CAAC,QAAQ;AAC3B,aAAa,6CAA6C;AAC1D,aAAa,6CAA6C;AAC1D,MAAM,YAAY,CAAC,QAAQ;AAC3B,WAAW,YAAY,CAAC,QAAQ,CAAC,6CAA6C;AAC9E,YAAY,YAAY,CAAC,OAAO,CAAC,cAAc,CAAC,kBAAkB;AAClE;;;EAGE,8BAA8B,EAAE,iBAAiB;EACjD,kBAAkB,cAAc,gBAAgB;EAChD,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B,EAAE,mCAAmC;EACpE,kCAAkC;EAClC,uBAAuB;EACvB,yCAAyC;EACzC,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA,WAAW;AACX;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,sCAAsC;EACtC,6BAA6B;EAC7B,0CAA0C;EAC1C,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;AAC7B;;;;AAIA;EACE,wBAAwB;EACxB,yBAAyB,EAAE,eAAe;EAC1C,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;;;EAGE,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;EAC7B,0CAA0C;EAC1C,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;;AAGA;EACE,8BAA8B;AAChC;;AAEA,QAAQ,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,cAAc;AAC9D,OAAO,mBAAmB,CAAC,kBAAkB,CAAC,OAAO,CAAC,eAAe,CAAC,mBAAmB,CAAC,8BAA8B,CAAC,kBAAkB,CAAC,cAAc;AAC1J,UAAU,aAAa,CAAC,kBAAkB,CAAC,oBAAoB;AAC/D,WAAW,kBAAkB;AAC7B,KAAK,uBAAuB,CAAC,8BAA8B,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,cAAc;AACjI,WAAW,2BAA2B;AACtC,aAAa,yBAAyB,CAAC,UAAU,CAAC,2BAA2B;AAC7E,aAAa,yBAAyB,CAAC,UAAU,CAAC,2BAA2B;AAC7E,YAAY,wBAAwB,CAAC,UAAU,CAAC,0BAA0B;AAC1E,QAAQ,gBAAgB,CAAC,cAAc;AACvC,OAAO,UAAU,CAAC,wBAAwB;AAC1C,oBAAoB,qCAAqC,CAAC,eAAe,CAAC,eAAe;AACzF,OAAO,cAAc,CAAC,WAAW,CAAC,UAAU,CAAC,uBAAuB,CAAC,8BAA8B,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,sCAAsC,CAAC,aAAa;AAC7L;AACA,wBAAwB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;EACvC,aAAa;AACf,WAAW;AACX;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA,gCAAgC;AAChC;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;;;;;EAKE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,8BAA8B,EAAE,iBAAiB;EACjD,kBAAkB,EAAE,gBAAgB;EACpC,eAAe;EACf,mBAAmB;EACnB,8DAA8D;AAChE;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;EAC1C,aAAa;AACf;AACA;EACE,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA,aAAa;AACb;EACE,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;AACA,YAAY,uBAAuB,CAAC,8BAA8B,CAAC,kBAAkB,CAAC,YAAY,CAAC,eAAe,CAAC,cAAc,CAAC,iBAAiB,CAAC,aAAa;AACjK,QAAQ,sBAAsB;AAC9B,eAAe;AACf,4BAA4B,aAAa,6CAA6C,EAAE;AACxF;EACE;IACE,0BAA0B;EAC5B;;AAEF;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;EAEE,qDAAqD;EACrD;IACE,wBAAwB;EAC1B;;EAEA,8DAA8D;EAC9D;IACE,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,gBAAgB;EAClB;AACF;AACA;EACE,0BAA0B,yBAAyB;EACnD,WAAW,yBAAyB;EACpC,YAAY,cAAc,CAAC,eAAe,CAAC,aAAa;AAC1D;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;;;AAIA,4BAA4B;AAC5B;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;;;IAGE,WAAW;EACb;AACF;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;;EAER,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY,EAAE,8CAA8C;EAC5D,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,2CAA2C,EAAE,aAAa;EAC1D,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB,EAAE,2BAA2B;EACrD,cAAc;AAChB;;;;AAIA,wBAAwB,CAAC;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA,UAAU;AACV;EACE,sBAAsB,IAAI,iBAAiB;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,WAAW,eAAe,gBAAgB;EAC1C,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;;AAGA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA,WAAW;AACX;EACE,eAAe;EACf,WAAW,EAAE,gBAAgB;EAC7B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,+BAA+B;AAC/B;;;EAGE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB,IAAI,iBAAiB;EAC3C,WAAW,eAAe,gBAAgB;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;;AAGA,WAAW;AACX;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB,IAAI,sBAAsB;EAChD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6BAA6B,CAAC,oBAAoB;AAClD;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA,UAAU;AACV;EACE,sBAAsB,IAAI,iBAAiB;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,WAAW,eAAe,gBAAgB;EAC1C,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;;AAEb;;AAEA,WAAW;AACX;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;;AAGA,wCAAwC,CAAC;EACvC,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA,UAAU;AACV;EACE,sBAAsB,IAAI,iBAAiB;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,WAAW,eAAe,gBAAgB;EAC1C,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB,IAAI,kBAAkB;EACtC,cAAc,MAAM,+BAA+B;EACnD,aAAa;AACf;;AAEA;EACE,0BAA0B,EAAE,kBAAkB;AAChD;AACA,0DAA0D;AAC1D;EACE,WAAW;EACX,gBAAgB,EAAE,8CAA8C;AAClE;AACA;EACE,aAAa;EACb,gCAAgC,EAAE,sCAAsC;AAC1E;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,iCAAiC;AACnC","sourcesContent":["\n:root { --bg:#0e1117; --panel:#161b22; --muted:#9aa4b2; --text:#e6edf3; --primary:#6ea8fe; --success:#3fb950; --warn:#f2cc60; --danger:#ff6b6b; --border:#262b36; }\n*{box-sizing:border-box}\nhtml,body{height:100%}\nbody{margin:0;font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,Arial,sans-serif;background:var(--bg);color:var(--text)}\n\n.sidebar {\n  width: 250px;\n  transition: width 0.3s ease, transform 0.3s ease;\n  background-color: #111;\n  overflow: hidden;\n}\n.sidebar.hidden {\n  transform: translateX(-250px); /* empurra pra fora da tela */\n}\n\n.brand{display:flex;gap:10px;align-items:center;padding:16px 14px;border-bottom:1px solid var(--border)}\n\n\n.brand-text small{color:var(--muted);display:block;margin-top:2px}\n.menu{padding:10px}\n.menu-section{color:var(--muted);font-size:12px;text-transform:uppercase;letter-spacing:.08em;padding:10px}\n.menu-item{display:block;padding:10px 12px;border-radius:10px;color:var(--text);text-decoration:none}\n.menu-item:hover{background:rgba(110,168,254,.08)}\n.sidebar-footer{margin-top:auto;padding:12px;display:flex;gap:8px;border-top:1px solid var(--border);align-items:center}\n.main {\n  display: flex;\n  height: 100vh; /* ocupa toda a altura da tela */\n  overflow: hidden; /* evita scroll global */\n  z-index:10;\n}\n.topbar{display:flex;align-items:center;justify-content:space-between;padding:10px 14px;border-bottom:1px solid var(--border);background:var(--panel)}\n.icon-btn{background:transparent;border:1px solid var(--border);color:var(--text);border-radius:10px;padding:8px 10px;cursor:pointer}\n.search input{background:transparent;border:1px solid var(--border);color:var(--text);border-radius:10px;padding:8px 10px;min-width:220px}\n.avatar{width:30px;height:30px;border-radius:999px;background:#334155;display:grid;place-items:center;font-size:12px}\n.content {\n  flex: 1;\n  overflow-y: auto; /* scroll só aqui */\n  \n  padding: 20px;\n}\n.footer{padding:12px 14px;border-top:1px solid var(--border);color:var(--muted);background:var(--panel)}\n.card{background:var(--panel);border:1px solid var(--border);border-radius:12px;padding:14px;overflow-x:auto}\n.card h2{margin:0 0 6px 0;font-size:18px}\n.card .sub{color:var(--muted);font-size:12px;margin-bottom:6px}\n.grid{display:grid;gap:12px}\n.grid.cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}\n.grid.cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}\n.form{display:grid;gap:10px}\n.form .row{display:grid;gap:10px;grid-template-columns:repeat(2,minmax(0,1fr))}\n.form label{display:grid;gap:6px;font-size:12px;color:var(--muted)}\n.form input,\n.form select,\n.form textarea {\n  background-color: var(--panel); /* fundo escuro */\n  color: var(--text);             /* texto claro */\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n.swal2-popup {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: stretch !important; /* garante alinhamento à esquerda */\n  justify-content: center !important;\n  width: 420px !important;\n  background-color: var(--panel) !important;\n  color: var(--text) !important;\n  border-radius: 12px !important;\n  padding: 32px 36px !important;\n  box-shadow: 0 0 25px rgba(0, 0, 0, 0.6) !important;\n}\n.swal2-html-container {\n  margin: 0 !important;\n  padding: 0 !important;\n  overflow: visible !important;\n}\n/* Título */\n.swal2-title {\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  color: var(--text) !important;\n  text-align: left !important;\n  margin-left: -25px !important;\n  margin-bottom: 18px !important;\n}\n\n/* Labels */\n.swal2-popup label {\n  display: block !important;\n  text-align: left !important;\n  font-size: 13px !important;\n  color: var(--muted) !important;\n  margin-bottom: 1px !important;\n}\n\n/* Inputs */\n.swal2-input {\n  width: 100% !important;\n  background-color: var(--bg) !important;\n  color: var(--text) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 8px !important;\n  padding: 10px 12px !important;\n  font-size: 14px !important;\n  margin-bottom: 16px !important;\n  margin-left: 0px !important;\n  box-shadow: none !important;\n}\n\n\n\n.swal2-popup.detalhes-popup {\n  width: 1200px !important;\n  max-width: 90% !important; /* responsivo */\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: stretch !important;\n  justify-content: center !important;\n}\n.swal2-html-container.detalhes-container {\n  max-height: 600px !important;\n  overflow-y: auto !important;\n}\n.btn.link {\n  background-color: #17a2b8; /* azul turquesa */\n  color: #fff;\n}\n.btn.link:hover {\n  background-color: #138496;\n}\n\n.swal2-input::placeholder {\n  color: var(--muted) !important;\n}\n\n.swal2-input:focus {\n  border-color: var(--primary) !important;\n  outline: none !important;\n}\n\n/* Botões */\n.swal2-confirm {\n  background-color: var(--success) !important;\n  color: #fff !important;\n  border-radius: 8px !important;\n  padding: 10px 24px !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  box-shadow: none !important;\n}\n.swal2-actions {\n  display: flex !important;\n  justify-content: center !important;\n  margin-top: 10px !important;\n}\n.swal2-checkbox,\n.swal2-checkbox input,\n.swal2-checkbox {\n  display: none !important;\n  visibility: hidden !important;\n  height: 0 !important;\n  width: 0 !important;\n  overflow: hidden !important;\n}\n.swal2-label {\n  display: block !important;\n  text-align: left !important;\n  font-size: 13px !important;\n  color: var(--muted) !important;\n  margin-bottom: 1px !important;\n  margin-left: 2px !important;\n}\n.swal2-input {\n  margin-bottom: 14px !important;\n}\n\n/* Remove scrolls e barras */\n.swal2-popup::-webkit-scrollbar,\n.swal2-html-container::-webkit-scrollbar {\n  display: none !important;\n}\n\n.swal2-cancel {\n  background-color: var(--panel) !important;\n  color: var(--text) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 8px !important;\n  padding: 8px 18px !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n}\n\n.swal2-timer-progress-bar-container,\n.swal2-timer-progress-bar {\n  display: none !important;\n}\n\n\n.swal2-input::placeholder {\n  color: var(--muted) !important;\n}\n\n.inline{display:flex;align-items:center;gap:8px;flex-wrap:wrap}\n.badge{display:inline-flex;align-items:center;gap:6px;padding:3px 8px;border-radius:999px;border:1px solid var(--border);color:var(--muted);font-size:12px}\n.badge.on{color:#0b1220;background:#a7f3d0;border-color:#a7f3d0}\n.badge.off{background:#1f2937}\n.btn{background:var(--panel);border:1px solid var(--border);color:var(--text);border-radius:10px;padding:10px 14px;cursor:pointer}\n.btn:hover{border-color:var(--primary)}\n.btn.primary{background:var(--primary);color:#fff;border-color:var(--primary)}\n.btn.success{background:var(--success);color:#fff;border-color:var(--success)}\n.btn.danger{background:var(--danger);color:#fff;border-color:var(--danger)}\n.btn-sm{padding:8px 12px;font-size:12px}\n.table{width:100%;border-collapse:collapse}\n.table th,.table td{border-bottom:1px solid var(--border);padding:8px 6px;text-align:left}\n.toast{position:fixed;bottom:16px;right:16px;background:var(--panel);border:1px solid var(--border);border-radius:10px;padding:10px 12px;box-shadow:0 10px 30px rgba(0,0,0,.25);z-index:11000}\n.modal{\nbackground: var(--panel);\n  color: var(--text);\n  border-radius: 10px;\n  padding: 30px 40px;\n  max-width: 480px;\n  margin: 40px auto;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);\n  z-index:10000}\n/* Título */\n.modal h2 {\n  text-align: center;\n  font-size: 22px;\n  margin-bottom: 25px;\n  color: var(--text);\n}\n/* Labels alinhados à esquerda */\n.modal label {\n  display: block;\n  text-align: left;\n  font-size: 13px;\n  color: var(--muted);\n  margin-bottom: 4px;\n  margin-left: 4px;\n}\n\n/* Inputs com fundo escuro e borda suave */\n.modal input[type=\"text\"],\n.modal input[type=\"email\"],\n.modal input[type=\"tel\"],\n.modal input[type=\"password\"],\n.modal input[type=\"number\"] {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background-color: var(--panel); /* fundo escuro */\n  color: var(--text); /* texto claro */\n  font-size: 14px;\n  margin-bottom: 14px;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n}\n\n.modal input:focus {\n  border-color: var(--primary);\n  background-color: rgba(110, 168, 254, 0.1);\n  outline: none;\n}\n.modal input::placeholder {\n  color: var(--muted); /* cor suave para placeholder */\n}\n\n/* Botão OK */\n.modal button {\n  display: block;\n  margin: 20px auto 0;\n  background: var(--primary);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 24px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.modal button:hover {\n  background: var(--primary-hover);\n}\n.modal>.box{background:var(--panel);border:1px solid var(--border);border-radius:12px;padding:16px;min-width:360px;max-width:90vw;position:relative;z-index:10001}\n.hidden{display:none!important}\n/* Responsive */\n@media (max-width: 1200px){ .grid.cols-3{grid-template-columns:repeat(2,minmax(0,1fr))} }\n@media (max-width: 900px) {\n  .layout {\n    grid-template-columns: 1fr;\n  }\n\n.sidebar {\n  width: 220px;\n  background-color: #121212;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n  /* Sidebar visível apenas quando NÃO estiver oculta */\n  body:not(.hide-sidebar) .sidebar {\n    transform: translateX(0);\n  }\n\n  /* Sidebar oculta (mantém compatibilidade com telas grandes) */\n  body.hide-sidebar .sidebar {\n    display: none;\n    transform: translateX(-100%);\n  }\n\n  .topbar .search {\n    display: none;\n  }\n\n  .btn,\n  .icon-btn {\n    min-height: 44px;\n  }\n}\n@media (max-width: 768px){\n  .grid.cols-2,.grid.cols-3{grid-template-columns:1fr}\n  .form .row{grid-template-columns:1fr}\n  .modal>.box{min-width:94vw;max-height:90vh;overflow:auto}\n}\n.filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n}\n\n.filters label {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n}\n\n.filters select,\n.filters input[type=\"date\"],\n.filters button {\n  margin-top: 4px;\n  padding: 6px;\n  font-size: 14px;\n}\n\n.swal-top {\n  z-index: 10002 !important;\n}\n.swal2-container {\n  z-index: 99999 !important;\n}\n\n\n\n/* Responsivo para celular */\n@media (max-width: 768px) {\n  .filters {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .filters select,\n  .filters input[type=\"date\"],\n  .filters button {\n    width: 100%;\n  }\n}\n\n.sidebar {\n  background: var(--panel);\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  width: 240px;\n  min-height: 100vh;\n  padding-top: 0;\n}\n\n.brand {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  \n  border-bottom: 1px solid var(--border);\n}\n\n.logo img {\n  width: 120px;\n  height: auto;\n  display: block;\n}\n\n.brand-text {\n  text-align: center;\n  color: var(--text);\n  font-size: 14px;\n}\n\n.brand-text strong {\n  color: var(--primary);\n  font-size: 16px;\n}\n\n.menu {\n  padding: 10px 0;\n}\n\n.menu-section {\n  color: var(--muted);\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  padding: 10px 16px 4px;\n}\n\n.menu-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  color: var(--text);\n  text-decoration: none;\n  border-radius: 8px;\n  transition: background 0.2s ease;\n}\n\n.menu-item:hover {\n  background: rgba(110, 168, 254, 0.1);\n}\n\n.menu-item i {\n  font-size: 16px;\n  color: var(--primary);\n}\n\n.sidebar-footer {\n  margin-top: auto;\n  padding: 12px 16px;\n  border-top: 1px solid var(--border);\n  color: var(--muted);\n  font-size: 12px;\n  text-align: center;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.logo img {\n  width: 120px; /* ajusta conforme o tamanho real do arquivo */\n  height: auto;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  display: block;\n}\n\n.logout {\n\n  background-color: var(--primary) !important; /* vermelho */\n  color: #fff;\n  padding: 2px 2px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.logout:hover {\n  background-color: #c82333;\n}\n\n.login-container {\n  max-width: 400px;\n  margin: 100px auto;\n  padding: 30px;\n  background-color: #1a1a1a;\n  border-radius: 8px;\n  color: #fff;\n}\n\n\n.login-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #121212;\n}\n\n.login-box {\n  background-color: var(--panel);\n  padding: 40px;\n  border-radius: 10px;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n  width: 30%;\n  color: #fff;\n}\n\n.login-box h3 {\n  margin-bottom: 20px;\n  text-align: center;\n  font-weight: 600;\n}\n\n.login-form label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 14px;\n}\n\n.login-form input {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 15px;\n  border: none;\n  border-radius: 5px;\n  background-color: #e9eef5;\n}\n\n.login-buttons {\n  display: flex;\n  justify-content: space-between;\n}\n\n.loginbtn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.loginbtn-green {\n  background-color: #28a745;\n  color: #fff;\n}\n\n.loginbtn-green:hover {\n  background-color: #218838;\n}\n\n.loginbtn-dark {\n  background-color: #343a40;\n  color: #fff;\n}\n\n.loginbtn-dark:hover {\n  background-color: #23272b;\n}\n\n\n.card-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: space-between;\n}\n\n.card.small {\n  flex: 1;\n  min-width: 300px;\n  background-color: var(--panel);\n  border: 1px solid #2b2c30;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 0 10px rgba(0,0,0,0.3);\n  transition: transform 0.2s ease;\n}\n\n.card.small:hover {\n  transform: translateY(-4px);\n}\n\n.card.small h4 {\n  margin-bottom: 10px;\n  color: #4da3ff;\n}\n\n.card.small p {\n  margin: 4px 0;\n  color: #ccc;\n}\n.indicadores {\n  display: flex;\n  align-items: center;\n}\n\n.indicadores .evolucao {\n  margin-left: 5px !important;\n}\n\n.card canvas {\n  width: 100% !important;\n  height: 280px !important; /* altura fixa e elegante */\n  display: block;\n}\n\n\n\n/* ===== Suporte ===== */.suporte-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n/* Cards */\n.suporte-container .card {\n  background-color: #fff;   /* fundo branco */\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 25px;\n  color: #000;              /* texto preto */\n  text-align: left;\n}\n\n/* Título */\n.suporte-container h2 {\n  margin: 0 0 10px 0;\n  font-size: 20px;\n  color: #4caf50;\n}\n\n\n/* Formulário */\n#formSuporte {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n/* Labels */\n#formSuporte label {\n  font-size: 14px;\n  color: #000; /* texto preto */\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n/* Inputs, selects e textarea */\n#formSuporte .form-input,\n#formSuporte select,\n#formSuporte textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px 10px;\n  font-size: 13px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background-color: #fff;   /* fundo branco */\n  color: #000;              /* texto preto */\n}\n\n#formSuporte textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n/* Botão principal */\n#formSuporte .btn.primary {\n  background-color: #4caf50;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  font-size: 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  width: 100%;\n}\n\n#formSuporte .btn.primary:hover {\n  background-color: #45a049;\n}\n\n/* Rodapé */\n.suporte-container .rodape {\n  font-size: 13px;\n  color: #555;\n  margin-top: 20px;\n}\n\n.suporte-container .rodape a {\n  color: #4caf50;\n  text-decoration: none;\n}\n\n\n/* Rodapé */\n.suporte-container .rodape {\n  font-size: 13px;\n  color: #aaa;\n  margin-top: 15px;\n}\n\n.suporte-container .rodape a {\n  color: #4caf50;\n  text-decoration: none;\n}\n\n.suporte-container p {\n  color: #000 !important;   /* força texto preto */\n  font-size: 14px;\n  line-height: 1.6;\n  margin-bottom: 10px;\n}\n\n/* ===== Termo de Uso ===== *//* Container geral */\n.termodeuso-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n/* Cards */\n.termodeuso-container .card {\n  background-color: #fff;   /* fundo branco */\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 25px;\n  color: #000;              /* texto preto */\n  text-align: left;\n}\n\n/* Título principal */\n.termodeuso-container h2 {\n  color: #4caf50;\n  margin-bottom: 10px;\n}\n\n/* Subtítulos */\n.termodeuso-container h3 {\n  color: #4caf50;\n  margin-top: 20px;\n  margin-bottom: 8px;\n  font-size: 16px;\n}\n\n/* Texto */\n.termodeuso-container p {\n  color: #333;\n  font-size: 14px;\n  line-height: 1.6;\n  margin-bottom: 10px;\n}\n\n/* Listas */\n.termodeuso-container ul {\n  margin-left: 20px;\n  color: #333;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.termodeuso-container li {\n  color: #333;\n  \n}\n\n/* Rodapé */\n.termodeuso-container .rodape {\n  font-size: 13px;\n  color: #555;\n  margin-top: 20px;\n}\n\n.termodeuso-container .rodape a {\n  color: #4caf50;\n  text-decoration: none;\n}\n\n\n/* ===== Política de Privacidade ===== */.politicaprivacidade-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n/* Cards */\n.politicaprivacidade-container .card {\n  background-color: #fff;   /* fundo branco */\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 25px;\n  color: #000;              /* texto preto */\n  text-align: left;\n}\n\n/* Título principal */\n.politicaprivacidade-container h2 {\n  color: #4caf50;\n  margin-bottom: 10px;\n}\n\n/* Subtítulos */\n.politicaprivacidade-container h3 {\n  color: #4caf50;\n  margin-top: 20px;\n  margin-bottom: 8px;\n  font-size: 16px;\n}\n\n/* Texto */\n.politicaprivacidade-container p {\n  color: #333;\n  font-size: 14px;\n  line-height: 1.6;\n  margin-bottom: 10px;\n}\n\n/* Listas */\n.politicaprivacidade-container ul {\n  margin-left: 20px;\n  color: #333;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n/* Rodapé */\n.politicaprivacidade-container .rodape {\n  font-size: 13px;\n  color: #555;\n  margin-top: 20px;\n}\n\n.politicaprivacidade-container .rodape a {\n  color: #4caf50;\n  text-decoration: none;\n}\n\nbody.hide-sidebar .main {\n  width: 100%;\n  max-width: 800px;   /* limite máximo */\n  margin: 0 auto;     /* centraliza horizontalmente */\n  padding: 20px;\n}\n\nbody.hide-sidebar .layout {\n  grid-template-columns: 1fr; /* só uma coluna */\n}\n/* Opcional: limitar largura dos cards dentro do Suporte */\nbody.hide-sidebar .main .card {\n  width: 100%;\n  max-width: 700px; /* deixa o card mais estreito e centralizado */\n}\n.layout {\n  display: grid;\n  grid-template-columns: 240px 1fr; /* exemplo: sidebar 240px + conteúdo */\n}\n\n.swal-recuperar-senha {\n  background: #fff !important;\n  color: #000 !important;\n}\n\n.swal-recuperar-senha .swal2-title,\n.swal-recuperar-senha .swal2-html-container label {\n  color: #000 !important;\n}\n\n.swal-recuperar-senha .swal2-input {\n  background: #fff !important;\n  color: #000 !important;\n  border: 1px solid #ccc !important;\n}\n\n.swal-recuperar-senha .swal2-input::placeholder {\n  color: #666 !important;\n}\n\n.swal-recuperar-senha .swal2-confirm {\n  background-color: #4caf50 !important;\n  color: #fff !important;\n}\n\n.swal-recuperar-senha .swal2-cancel {\n  background-color: #f5f5f5 !important;\n  color: #000 !important;\n  border: 1px solid #ccc !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
